import { createSelector } from '@ngrx/store';
import { getLoyaltyAppSettings } from '../getLoyaltyAppSettings';

export const getLoyaltyAppDataReady = createSelector(getLoyaltyAppSettings, (settings) => settings.hasSucceeded && Boolean(settings.data));
